"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/toConsumableArray.js"));
var _banner = _interopRequireDefault(require("@/components/banner.vue"));
var _search = _interopRequireDefault(require("@/components/search.vue"));
var _menus = _interopRequireDefault(require("@/components/menus.vue"));
var _nav = _interopRequireDefault(require("@/components/nav.vue"));
var _winCourse = _interopRequireDefault(require("@/components/winCourse.vue"));
require("../index.less");
var _public = require("@/api/public/public");
var _beforeMen = require("@/api/beforeMen/beforeMen");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Banner: _banner.default,
    Search: _search.default,
    Nav: _nav.default,
    Menus: _menus.default,
    WinCourse: _winCourse.default
  },
  filters: {
    date: function date(val) {
      return val.slice(0, 10);
    },
    day: function day(val) {
      return val.slice(8, 10);
    },
    year: function year(val) {
      return val.slice(0, 7);
    }
  },
  data: function data() {
    return {
      imgBanner: require("../../../assets/img/banner6.png"),
      tabList: ['赛事公告', '作品展示'],
      curIndex: 0,
      menusList: [{
        tit: '比赛类型',
        itemList: [{
          name: '全部',
          id: ''
        }, {
          name: '班主任大赛',
          id: ''
        }, {
          name: '教学能力大赛',
          id: ''
        }, {
          name: '精品在线课评审',
          id: ''
        }],
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '层次',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wCourseLevel)),
        actheight: false,
        act: 0,
        isZhan: false
      }, {
        tit: '年份',
        itemList: [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(this.$store.getters.wYearListAll)),
        actheight: false,
        act: 0,
        isZhan: false
      }],
      total0: 0,
      total1: 0,
      query0: {
        name: "",
        pageNum: 1,
        pageSize: 20,
        provinceId: this.$store.getters.provinceId,
        status: 1
      },
      query1: {
        name: "",
        pageNum: 1,
        pageSize: 20,
        provinceId: this.$store.getters.provinceId
      },
      list: [],
      workList: []
    };
  },
  methods: {
    handleCurrentChange: function handleCurrentChange(e) {
      this.query0.pageNum = e;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(e) {
      this.query0.pageSize = e;
      this.query0.pageNum = 1;
      this.getList();
    },
    tabs: function tabs(i, j) {
      this.curIndex = j;
    },
    chooseList: function chooseList(e) {
      // if(e[0]=='比赛类型'){
      //   this.query.industryClassification = e[1]
      // }else if(e[0]=='行业门类'){
      //   this.query.industryCategory = e[1]
      // }else if(e[0]=='项目级别'){
      //   this.query.projectLevel = e[1]
      // }else if(e[0]=='媒体类型'){
      //   this.query.mediaType = e[1]
      // }else if(e[0]=='应用类型'){
      //   this.query.applicationType = e[1]
      // }else if(e[0]=='类型'){
      //   this.query.repositoryType = e[1]
      // }
      // this.getList();
    },
    //比赛类型 查询全部
    getTypeList: function getTypeList() {
      var _this = this;
      (0, _beforeMen.contestType)({
        provinceId: this.$store.getters.provinceId
      }).then(function (res) {
        _this.menusList[0].itemList = [{
          name: '全部',
          id: ''
        }].concat((0, _toConsumableArray2.default)(res.data));
      });
    },
    //赛事公告列表
    getNewsList: function getNewsList(e) {
      var _this2 = this;
      (0, _beforeMen.contestNotice)(this.query0).then(function (res) {
        _this2.list = res.data.list;
        _this2.total0 = res.data.total;
        console.log("this.list", _this2.list);
      });
    },
    lookDetail: function lookDetail(e) {
      this.$router.push({
        path: "/newsDetail",
        query: {
          id: e.id
        }
      });
    },
    toComDetail: function toComDetail(item) {
      this.$router.push({
        path: "/competitionDetail"
      });
    }
  },
  created: function created() {
    this.getTypeList();
    this.getNewsList();
  }
};